module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/arrow-right-line-ff561c304c838169cece716204e28477.svg";